import React from 'react';
import { useAgentSurface } from '../lib/useAgentSurface';
import AgentAvatarSphere from './AgentAvatarSphere';
import TCRobotAvatar from './TCRobotAvatar';

/**
 * AgentAvatar — Phase 12 route dispatcher.
 *
 * Two visual variants share the same visibility gate + tone from
 * useAgentSurface():
 *
 *   • Consumer routes (/, /consumer/*)  → BioluminescentSphere (Phase 9)
 *   • Talent Connect routes (except /candidate*) → TCRobotAvatar (Phase 12)
 *   • Hidden routes (POC, legal, candidate) → returns null
 *
 * The sphere and robot each own their physics (drag / magnetic / drift)
 * and popover UI. This wrapper is pure routing plumbing so we don't leak
 * TC-specific logic into the consumer variant, and vice-versa.
 */

function isConsumerRoute(pathname) {
  return pathname === '/' || pathname === '/consumer' || pathname.startsWith('/consumer/');
}

function isTalentConnectRoute(pathname) {
  if (!pathname.startsWith('/talent-connect')) return false;
  if (pathname === '/talent-connect/candidate' || pathname.startsWith('/talent-connect/candidate/')) {
    return false;
  }
  return true;
}

export default function AgentAvatar() {
  const { visible, tone, popoverContent, pathname } = useAgentSurface();
  if (!visible) return null;

  if (isTalentConnectRoute(pathname)) {
    return <TCRobotAvatar tone={tone} />;
  }
  if (isConsumerRoute(pathname)) {
    return <AgentAvatarSphere tone={tone} popoverContent={popoverContent} />;
  }
  // Fallback — useAgentSurface().shouldHide should already have caught this,
  // but keep the guard so untagged future routes stay quiet.
  return null;
}
